import React from 'react'
import styled from 'styled-components'

import { Text } from 'components/typo'
import { helper } from 'utils'

import OtpInput from './OtpInput'
import Button from '../../../components/button/Button'

const VerifyOtp = (props) => {
  const { loading, mobile, onCheckCode, onResend, onBack } = props

  const onSend = () => onResend(mobile)

  const text = helper.formatPattern(mobile, 'xxx-xxx-xxxx')
  return (
    <Title>
      <Text size="large" bold>
        ผูกหมายเลขโทรศัพท์
      </Text>

      <OtpCode>ระบุรหัส OTP ที่ได้รับ</OtpCode>
      <Mobile>ส่งไปที่หมายเลข {text}</Mobile>

      <OtpInput onComplete={onCheckCode} />
      <ButtonBox>
        <Button
          size="small"
          fontSize="xsmall"
          loading={loading}
          color="text"
          onClick={onSend}
        >
          ส่งรหัสใหม่อีกครั้ง
        </Button>
        <Button size="small" fontSize="xsmall" color="text" onClick={onBack}>
          เปลี่ยนหมายเลขโทรศัพท์
        </Button>
      </ButtonBox>
    </Title>
  )
}

const Title = styled.div`
  margin: 0 0 36px;
  text-align: center;
`

const OtpCode = styled.div`
  margin-top: 24px;
  font-size: 24px;
  color: #4e4b66;
`

const Mobile = styled.div`
  margin-top: 8px;
  margin-bottom: 40px;
  font-size: 18px;
  color: #4e4b66;
`

const ButtonBox = styled.div`
  margin-top: 40px;
`

export default VerifyOtp
